// extracted by mini-css-extract-plugin
module.exports = {"metaItem":"MetaItem-module--metaItem--3-QfV","title":"MetaItem-module--title--2dHXe"};